import { IconPropsType } from '..';

export const LiveDealerIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=dealer, currency=default">
        <path
          id="Vector"
          d="M12.6425 3.03506H12.4253L9.9638 3.85249L7.5025 3.03506C7.06812 2.89882 6.56153 3.17147 6.48895 3.64813V5.35111C6.48895 5.8276 6.92333 6.16854 7.35771 6.16854H7.5749L9.96398 5.14675L12.4251 6.16854C12.9319 6.30478 13.3663 6.03196 13.5111 5.55547V3.85249C13.5111 3.37582 13.0769 3.03506 12.6425 3.03506ZM8.73288 15.9096L5.47503 5.6917C5.25784 5.28299 4.82347 5.07863 4.31687 5.21504L3.23092 5.55581C2.86876 5.62393 2.65157 5.96452 2.65157 6.30529L2 16.1144C2 16.5913 2.36216 16.9319 2.79654 17H7.86412C8.37072 17 8.73288 16.6591 8.73288 16.1826C8.8051 16.1144 8.73288 15.9775 8.73288 15.9096ZM17.276 6.30478C17.276 5.96418 17.0588 5.69171 16.6969 5.55547L15.6109 5.14675C15.1765 5.01017 14.6698 5.21453 14.525 5.62325L11.2671 15.8411C11.122 16.2498 11.4119 16.7267 11.8463 16.8629C11.9187 16.8629 11.9913 16.931 12.1359 16.931H17.1312C17.6377 16.931 18 16.5901 18 16.1136L17.276 6.30478Z"
        />
      </g>
    </svg>
  );
};
